import { Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import type { ReactNode } from 'react'

const domain = import.meta.env.VITE_AUTH0_DOMAIN || ''
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID || ''
const audience = import.meta.env.VITE_AUTH0_AUDIENCE || ''

export function Auth0ProviderWithNavigate({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  function onRedirectCallback(appState?: { returnTo?: string }) {
    navigate(appState?.returnTo || '/')
  }

  if (!domain || !clientId) {
    return <>{children}</>
  }

  const authParams: Record<string, string> = {
    redirect_uri: window.location.origin,
  }
  if (audience) {
    authParams.audience = audience
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={authParams}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}
